import { defineComponent } from 'vue'
import { Checkbox } from 'vant'
import './checkbox-compat.less'
import CheckLight from './assets/check-light.svg'
import NormalLight from './assets/normal-light.svg'

export default defineComponent({
  name: 'VanCheckbox',
  inheritAttrs: true,
  setup(_, { attrs, slots }) {
    return () => {
      const { ...rest } = attrs as Record<string, unknown>

      return (
        <Checkbox
          {...rest}
          icon-size="16px"
          class="fsw-van-checkbox"
          v-slots={{
            icon: ({ checked }: { checked?: boolean }) => {
              return checked ? <CheckLight /> : <NormalLight />
            },
            ...slots,
          }}
        />
      )
    }
  },
})
